import{_ as r}from"./_nativeCreate.js";var a=r,t=Object.prototype.hasOwnProperty;var _=function(r){var _=this.__data__;if(a){var e=_[r];return"__lodash_hash_undefined__"===e?void 0:e}return t.call(_,r)?_[r]:void 0};export{_};
